export default __webpack_public_path__ + "static/media/icon-arrowDown.c145cb4f.svg";